module.exports = __webpack_public_path__ + "img/up.c08a2164.png";